export default {
  setRoles(state, roles) {
    state.roles = roles
  },

  setUsers(state, users) {
    state.users = users
  },

  updateUserRole(state, { userId, roleId }) {
    const user = state.users.find(({ id }) => userId === id)
    const role = state.roles.find(({ id }) => roleId === id)

    if (user && role) {
      user.role = role
    }
  },
}
